import React from 'react';
import { Button } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import { signInWithPopup, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth, provider } from '../firebase';
import { setCookie } from '../cookieUtils';

const parseSuperAdmins = () =>
  (process.env.REACT_APP_SUPERADMINS || '')
    .split(',')
    .map((e) => e.trim().toLowerCase())
    .filter(Boolean);

const SuperadminLoginButton = ({
  redirectTo = '/tenant-page',
  label = 'Superadmin Sign In',
  superAdminEmails,
  onError,
}) => {
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const email = user?.email?.toLowerCase();
      const superAdmins = Array.isArray(superAdminEmails)
        ? superAdminEmails.map((e) => (e || '').toLowerCase()).filter(Boolean)
        : parseSuperAdmins();

      if (!email || !superAdmins.includes(email)) {
        await signOut(auth);
        const message = 'This account is not configured as Superadmin.';
        if (typeof onError === 'function') {
          onError(message);
        } else {
          alert(message);
        }
        return;
      }

      const token = await user.getIdToken();
      setCookie('userData', { email, token });
      navigate(redirectTo);
    } catch (error) {
      console.error('Superadmin sign-in failed:', error);
      if (typeof onError === 'function') {
        onError(error?.message || 'Superadmin sign-in failed');
      }
    }
  };

  return (
    <Button onClick={handleLogin} startIcon={<LoginIcon />} sx={{ textTransform: 'none' }}>
      {label}
    </Button>
  );
};

export default SuperadminLoginButton;
